import { render, staticRenderFns } from "./sequenceAnalyticsPage.vue?vue&type=template&id=952248b0&scoped=true&"
import script from "./sequenceAnalyticsPage.vue?vue&type=script&lang=ts&"
export * from "./sequenceAnalyticsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952248b0",
  null
  
)

export default component.exports